import { useContext, useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { PersonalData } from "../../components/Candidate Portal/Account Tabs/PersonalData";
import { SummeryDetails } from "../../components/Candidate Portal/Account Tabs/SummeryDetails";
import { Experience } from "../../components/Candidate Portal/Account Tabs/Experience";
import { Education } from "../../components/Candidate Portal/Account Tabs/Education";
import { ProfessionalProfile } from "../../components/Candidate Portal/Account Tabs/ProfessionalProfile";
import { Preferences } from "../../components/Candidate Portal/Account Tabs/Preferences";
import { HighLights } from "../../components/Candidate Portal/Account Tabs/HighLights";
import { DataProvider } from "../../store/ContextProvider";
import MandatoryBadge from "../../layouts/ui/MandatoryBadge";
import Loading from "../Loading";
import { fetchCandidate } from "../../services/Candidate Portal/Profile/fetchCandidateDetails";
import SuccessPage from "./SuccessPage";

export const AccountRouter = () => {
    const { BeURL } = useContext(DataProvider)
    const { page } = useParams();
    const [searchParams] = useSearchParams();
    const { currentUser } = useContext(DataProvider);
    const [error, setError] = useState("")
    const [candidate, setCandidate] = useState(null)

    const userId = searchParams.get("userId") || currentUser._id;

    const fetchCandidateData = () => fetchCandidate(BeURL, currentUser, setCandidate, setError)

    useEffect(() => {
        if (BeURL && currentUser?.role==="job-seeker") {
            fetchCandidateData()
        }
    }, [BeURL])

    const renderPage = () => {
        switch (page) {
            case "skills": return <ProfessionalProfile userId={userId} candidate={candidate} fetchCandidateData={fetchCandidateData} />;
            case "personalInformation": return <PersonalData userId={userId} candidate={candidate} fetchCandidateData={fetchCandidateData} />;
            case "profilesummery": return <SummeryDetails userId={userId} candidate={candidate} fetchCandidateData={fetchCandidateData} />;
            case "education": return <Education userId={userId} candidate={candidate} fetchCandidateData={fetchCandidateData} />;
            case "experience": return <Experience userId={userId} candidate={candidate} fetchCandidateData={fetchCandidateData} />;
            case "highlights": return <HighLights userId={userId} candidate={candidate} fetchCandidateData={fetchCandidateData} />;
            case "preferences": return <Preferences userId={userId} candidate={candidate} fetchCandidateData={fetchCandidateData} />;
            case "success": return <SuccessPage userId={userId} candidate={candidate} fetchCandidateData={fetchCandidateData} />;
            default: return <PersonalData userId={userId} candidate={candidate} fetchCandidateData={fetchCandidateData} />;
        }
    };

    if (!candidate || !BeURL || !currentUser) return <Loading />

    return <div>
        {error && <MandatoryBadge error />}
        {renderPage()}
    </div>;
};